import { Attribute } from 'models'
import { EnumLiteralsOf } from 'utilities'

export const sizes = {
  standard: 'standard' as 'standard',
  small: 'small' as 'small'
}
export type Size = EnumLiteralsOf<typeof sizes>;

export interface Props {
  attribute: Attribute
  size?: Size
}
